import { useId } from 'react';

export function ChatAiIcon() {
  const linearGradientId = useId();

  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 351.65 351.65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="w-full max-w-sm h-auto" // Added responsive sizing for the component
    >
      <defs>
        <style type="text/css">
          {`
            .cls-1, .cls-2 {
              fill: none;
            }

            .cls-2 {
              strokeMiterlimit: 10;
              strokeWidth: 9.9px;
            }

            .cls-2, .cls-3, .cls-4 {
              stroke: #fff;
            }

            .cls-8 {
              fill: #fff;
            }

            /* cls-9 is not used for the middle icon */
            .cls-9 {
              fill: #22333b;
            }

            /* cls-3 is used for the middle icon's star/diamond shape, which has a thicker stroke */
            .cls-3 {
              strokeWidth: 15.7px;
              strokeLinejoin: round;
              fill: #22333b;
            }

            .cls-4 {
              strokeLinejoin: round;
              strokeWidth: 6.7px;
              fill: #22333b;
            }
          `}
        </style>
        {/*
          Gradient definition coordinates have been shifted left by 499.4 units (Offset to center the middle logo).
          Original: x1="542.46" y1="85.14" x2="773.57" y2="305.04"
          New: x1: 542.46 - 499.4 = 43.06
          New: x2: 773.57 - 499.4 = 274.17
        */}
        <linearGradient
          id={linearGradientId}
          x1="43.06"
          y1="85.14"
          x2="274.17"
          y2="305.04"
          gradientTransform="translate(0 378.7) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#00857d" />
          <stop offset="0" stopColor="#088a82" />
          <stop offset=".2" stopColor="#1d9990" />
          <stop offset=".3" stopColor="#41b0a6" />
          <stop offset=".4" stopColor="#64c8bd" />
          <stop offset=".5" stopColor="#4bb0c0" />
          <stop offset=".8" stopColor="#1a81c6" />
          <stop offset="1" stopColor="#0870c9" />
        </linearGradient>
      </defs>

      {/* The main shape for the middle logo (outline style).
        The center coordinates (659.55) were shifted left by 499.4 to 160.15.
      */}
      <path
        style={{ fill: `url(#${linearGradientId})` }}
        d="M160.15,22.65c-88.1,0-159.5,71.4-159.5,159.5s71.4,159.5,159.5,159.5,159.5-71.4,159.5-159.5S248.25,22.65,160.15,22.65h0ZM160.15,322.55c-77.5,0-140.4-62.8-140.4-140.4s62.8-140.4,140.4-140.4,140.4,62.8,140.4,140.4-62.8,140.4-140.4,140.4Z"
      />

      {/* The star/diamond element coordinates were shifted left by 499.4.
        This uses cls-3 from the original SVG (thick stroke).
      */}
      <polygon
        className="cls-3"
        points="311.85 70.95 310.15 69.95 308.35 69.05 306.15 67.85 287.55 57.75 276.25 36.85 275.25 35.15 260.55 7.85 260.55 7.85 245.75 35.15 244.85 36.95 233.55 57.75 213.85 68.35 212.65 69.05 210.95 69.95 209.05 70.95 183.65 84.75 208.45 98.15 210.95 99.45 212.65 100.45 233.55 111.75 243.05 129.35 244.85 132.55 245.75 134.35 246.55 135.85 260.55 161.65 274.05 136.65 275.25 134.35 276.25 132.55 277.45 130.25 287.55 111.75 306.15 101.65 308.35 100.45 310.15 99.45 312.75 98.05 337.35 84.75 311.85 70.95"
      />
    </svg>
  );
}
